import { render, staticRenderFns } from "./getPanelsNumber.vue?vue&type=template&id=a86c0ce8&scoped=true"
import script from "./getPanelsNumber.vue?vue&type=script&lang=js"
export * from "./getPanelsNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86c0ce8",
  null
  
)

export default component.exports